import { ROUTE } from 'shared/constants/routes_old';
import { Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RegisterSuccessContainer = styled('div', { name: 'RegisterSuccessContainer' })(
	({ theme }) => ({
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing(6),
		textAlign: 'center',
	})
);

function RegisterSuccess() {
	return (
		<RegisterSuccessContainer>
			<Typography variant="h2">
				Please confirm your email address to complete Registration
			</Typography>
			<Typography>
				Please check your inbox for an email to be able to <Link href={ROUTE.login}>login</Link>
			</Typography>
		</RegisterSuccessContainer>
	);
}

export default RegisterSuccess;
